import { all } from 'redux-saga/effects';
import { sagas as userProfile } from './modules/userProfile/saga';
import { sagas as dashboardStats } from './modules/dashboardStats/saga';
import { sagas as reporting } from './modules/reporting/saga';
import { sagas as signup } from './modules/signup/saga';
import { sagas as login } from './modules/login/saga';
import { sagas as logout } from './modules/logout/saga';
import { sagas as superAdmin } from './modules/superAdmin/saga';
import { sagas as selfSignUp } from './modules/selfSignUp/saga';
import { sagas as support } from './modules/support/saga';
import { sagas as notification } from './modules/notification/saga';
import { sagas as rewards } from './modules/rewards/saga';
import { sagas as billing } from './modules/billing/saga';
import { sagas as roiCalculator } from './modules/roiCalculator/saga';

export default function* rootSaga() {
  yield all(
    [
      ...userProfile,
      ...dashboardStats,
      ...reporting,
      ...signup,
      ...login,
      ...logout,
      ...superAdmin,
      ...selfSignUp,
      ...support,
      ...notification,
      ...rewards,
      ...billing,
      ...roiCalculator,
    ]
      .map((func) => func())
      .concat(),
  );
}
